import { ItemType } from './ItemType';
export function isSectionMenuContentItem(item) {
    return item.itemType === ItemType.Section;
}
export function ensureMenuContentItemIsSectionContentItem(item) {
    if (!isSectionMenuContentItem(item)) {
        throw Error('Expected item to be SectionMenuContentItem.');
    }
}
// represents content item in the main navigation for easier access
export class MenuContentItem {
    constructor(item, trackingStatus, isActive, isLocked = false) {
        this.itemId = item.id;
        this.trackingStatus = trackingStatus;
        this.title = item.title;
        this.itemType = item.type;
        this.isActive = isActive;
        this.isLocked = isLocked;
    }
}
export class HotspotMenuContentItem extends MenuContentItem {
    constructor(item, trackingStatus, isActive, isLocked = false, title) {
        super(item, trackingStatus, isActive, isLocked);
        this.title = title;
    }
}
export class SectionMenuContentItem extends MenuContentItem {
    constructor(item, trackingStatus, isActive, childItems) {
        super(item, trackingStatus, isActive);
        this.childItems = childItems;
    }
    get isExpanded() {
        const hasActiveChild = this.childItems.some((item) => isSectionMenuContentItem(item) ? item.isExpanded || item.isActive : item.isActive);
        return hasActiveChild;
    }
}
